import { Injectable } from '@angular/core';
import 'parse';
const parse: typeof Parse = require('parse');
import { ParseService } from "./parse.service";
import { Tchekb } from '../model/tchekb.model';
import { Vehicle } from '../model/vehicle.model';
import { Damage, Roi } from '../model/damage.model';

@Injectable()
export class LogsService {

  constructor() { }

  public saveLog(log: string, tchekId: string, vehicleId? : string, damageId ?: string, roiId ?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let Logs = parse.Object.extend("Logs");
      let logs = new Logs();
      logs.set("userPtr", parse.User.current());
      logs.set("log", log);
      let tchekPtr = {
        __type: "Pointer",
        className: "Tchek",
        objectId: tchekId
      };
      logs.set("tchekPtr", tchekPtr);
      if (vehicleId) {
        let vehiclePtr = {
          __type: "Pointer",
          className: "Vehicle",
          objectId: vehicleId
        };
        logs.set("vehiclePtr", vehiclePtr);
      }
      if (damageId) {
        let damagePtr = {
          __type: "Pointer",
          className: "Damage",
          objectId: damageId
        };
        logs.set("damagePtr", damagePtr);
      }
      if (roiId) {
        let roiPtr = {
          __type: "Pointer",
          className: "Roi",
          objectId: roiId
        };
        logs.set("roiPtr", roiPtr);
      }
      logs.save(null, {
        success: function (gameScore) {
          // The object was saved successfully.
        },
        error: function (gameScore, error) {
          // The save failed.
          // error is a parse.Error with an error code and message.
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/logs.service.ts